import { createSelector } from "reselect";

const selectTranslations = (state) => state.translations || {};

export const getLanguages = createSelector(
  [selectTranslations],
  (translations) => translations.list || []
);